import { useQuery } from '@tanstack/react-query';
import { awaitJSON, StreamingOrdersLambdaFetch } from '@src/utils/fetch-utils';
import { PendingAgentOrder } from './agent-plan-buy-constants';

// The agent's orders for the company that are not sent yet.
export const useAgentOrders = (company: string): ReturnType<typeof useQuery<PendingAgentOrder[]>> =>
  useQuery({
    queryKey: ['agentPlanBuyOrders', company],
    queryFn: async () => {
      const res = await StreamingOrdersLambdaFetch('/agent_orders/pending', {
        params: { company }
      });
      const { pending } = await awaitJSON<{ pending: PendingAgentOrder[] }>(res);
      return pending;
    }
  });

export const approveAgentOrder = async (id: number): Promise<void> => {
  await StreamingOrdersLambdaFetch('/agent_orders/approve', { method: 'POST', body: { id } });
};

// DELETE /orders only deletes an order that is not sent (status 0, revision 1).
export const deleteAgentOrder = async (id: number): Promise<void> => {
  await StreamingOrdersLambdaFetch('/orders', { method: 'DELETE', params: { id } });
};
